import * as React from 'react';

import * as Styled from './connection-degree.styles';
import type { ConnectionDegreeProps } from './connection-degree.types';
import { useConnectionDegreeLabel } from './connection-degree.util';

export const ConnectionDegree = React.forwardRef<
  HTMLAnchorElement,
  ConnectionDegreeProps
>(
  (
    {
      children,
      className,
      size,
      sizeConfined,
      sizeWide,
      sizeXWide,
      variant,
      ...props
    },
    forwardedRef
  ) => {
    const ariaLabel = useConnectionDegreeLabel(children);

    return (
      <Styled.ConnectionDegreeBadge
        $variant={variant}
        aria-label={ariaLabel}
        className={className}
        data-xds="ConnectionDegree"
        ref={forwardedRef}
        size={size}
        sizeConfined={sizeConfined}
        sizeWide={sizeWide}
        sizeXWide={sizeXWide}
        {...props}
      >
        {children}
      </Styled.ConnectionDegreeBadge>
    );
  }
);

ConnectionDegree.displayName = 'ConnectionDegree';
